import React, { FC, useRef, useState } from 'react'
import styles from './FAQItem.module.scss'


type TFAQItem = {
    item: any
}

const FAQItem: FC<TFAQItem> = ({item}) => {
    const [ isActivePoint, setIsActivePoint ] = useState(false);

    const onHandleAnswer = () => {
        setIsActivePoint(!isActivePoint)
    }

    const faqClass = isActivePoint && styles['active'];

    return (
        <div 
            className={`${styles.faq__item} ${faqClass} faq`}
            onClick={onHandleAnswer}
        >
            <div className={styles.faq__info}>
                <h4 className={styles.faq__point}>{item.faqQuestion}</h4>
                <p className={styles.faq__answer}>
                    {item.faqAnswer}
                </p>
            </div>
            <button aria-label='Expand/contract' className='button'>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10.8332 13.4763L15.3032 9.00633L16.4817 10.1848L9.99992 16.6667L3.51807 10.1848L4.69657 9.00633L9.16658 13.4763L9.16658 3.33333H10.8332L10.8332 13.4763Z" fill="#13808D"/>
                </svg>
            </button>
            
        </div>
    )
}

export default FAQItem